import React from 'react';
import { Server } from 'lucide-react';
import ServiceHeader from '../../components/services/ServiceHeader';
import ServiceFeatureCard from '../../components/ui/ServiceFeatureCard';
import { colors } from '../../styles/theme';
import ServiceSteps from '../../components/services/sections/ServiceSteps';

const features = [
  {
    iconName: "Cpu",
    title: "Performance",
    description: "Dedicated CPU and guaranteed RAM"
  },
  {
    iconName: "HardDrive",
    title: "NVMe Storage",
    description: "Ultra-fast disks in RAID"
  },
  {
    iconName: "Network",
    title: "10 Gbps French Network",
    description: "Guaranteed bandwidth"
  },
  {
    iconName: "Shield",
    title: "Security",
    description: "DDoS protection included"
  },
  {
    iconName: "Terminal",
    title: "Root Access",
    description: "Full control of the server"
  },
  {
    iconName: "BarChart",
    title: "Monitoring",
    description: "Real-time supervision"
  }
];

const plans = [
  {
    name: "VPS-DEV",
    specs: [
      "1 vCPU",
      "1 GB RAM",
      "4 GB SSD NVMe",
      "1 dedicated IPv4",
      "Unlimited traffic",
      "DDoS protection"
    ]
  },
  {
    name: "VPS-PRO",
    specs: [
      "4 vCPU",
      "8 GB RAM",
      "50 GB SSD NVMe",
      "1 dedicated IPv4",
      "Unlimited traffic",
      "DDoS protection+"
    ]
  }
];

const steps = [
  {
    title: "Sign up on EUROPEAN STUDENT",
    description: "Create your student account in a few clicks"
  },
  {
    title: "Verify your student status",
    description: "Upload your student card or certificate of enrollment"
  },
  {
    title: "Order your VPS",
    description: "Choose your plan and deploy your server"
  }
];

const VPSPage = () => {
  const handleOrder = () => {
    window.location.href = 'https://my.europeanstudent.org/store/vps';
  };
  return (
    <div>
      <ServiceHeader
        title="Virtual Private Server"
        description="High-performance VPS for your projects, with full control over your environment."
        icon={<Server className="w-8 h-8 text-white" />}
        color={colors.accent2}
        imageUrl="https://images.unsplash.com/photo-1597852074816-d933c7d2b988?auto=format&fit=crop&q=80"
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* Features */}
        <div className="grid md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <ServiceFeatureCard
              key={index}
              iconName={feature.iconName}
              title={feature.title}
              description={feature.description}
              color={colors.accent2}
            />
          ))}
        </div>

        {/* VPS Plans */}
        <section className="mt-16">
          <h2 className="text-2xl font-bold mb-8">Our VPS Plans</h2>
          <div className="grid md:grid-cols-3 gap-8">
            {plans.map((plan, index) => (
              <div key={index} className="bg-white rounded-2xl shadow-lg p-8">
                <h3 
                  className="text-xl font-bold mb-4"
                  style={{ color: colors.accent2 }}
                >
                  {plan.name}
                </h3>
                <ul className="space-y-3 text-gray-600">
                  {plan.specs.map((spec, i) => (
                    <li key={i} className="flex items-center">
                      <span 
                        className="w-2 h-2 rounded-full mr-2"
                        style={{ backgroundColor: colors.accent2 }}
                      />
                      {spec}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </section>
        <div className="pt-11">
          <ServiceSteps
                title="How to Benefit"
                steps={steps}
                color={colors.accent2}
                ctaText="Order my VPS"
                onCtaClick={handleOrder}
          />
        </div>
      </div>
    </div>
  );
};

export default VPSPage;